import { http } from "api/http";

const getMcaClients = ({ queryKey }: any) => {
  return http.get("/mca-client", {
    params: { ...queryKey[1] },
  });
};

const addMcaCredential = (data: any) => {
  return http.post("/mca-client/credentials", data);
};

const updateMcaCredential = (data: any) => {
  return http.put(`/mca-client/credentials/${data?.id}`);
};

export {
  getMcaClients,
  addMcaCredential,
  updateMcaCredential,
};
